import { loadUnseenCount } from '@ms/yammer-data/dist/domains/notificationPaginations/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

type UseLoadUnseenNotifications = () => void;
export const useLoadUnseenNotifications: UseLoadUnseenNotifications = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadUnseenCount());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
